import { useInject } from '@vk-hr-tek/core/ioc';
import { ValidationService } from '@vk-hr-tek/core/validation';
import { FormError, TextInput, Form } from '@vk-hr-tek/app-ui/form';
import { FormKnownValue, FormKnownValues } from '@vk-hr-tek/ui/form';
import { Redo } from '@vk-hr-tek/ui/Redo';
import { Link } from '@vk-hr-tek/ui/Link';
import { Box } from '@vk-hr-tek/ui/Box';
import { Icon } from '@vk-hr-tek/ui/Icon';
import { Callout } from '@vk-hr-tek/ui/Callout';
import { Typography } from '@vk-hr-tek/ui/Typography';

import { useDispatch, useSelector } from '@app/hooks';

import {
  registerInitOAuth2,
  selectNotification,
  selectPhone,
  selectStatus,
  registerOAuth2,
  setStage,
  selectAuthInstance,
} from '../../../slice';
import { RegisterOAuth2Dto, RegisterOAuth2InitDto } from '../../../dto';
import { Button } from '../../../segments';

export const RegisterFinish = () => {
  const dispatch = useDispatch();
  const validator = useInject(ValidationService);

  const phone = useSelector(selectPhone);
  const error = useSelector(selectNotification);
  const status = useSelector(selectStatus);
  const authInstance = useSelector(selectAuthInstance);

  const { button_color: buttonColor } = authInstance;

  const onSubmit = (values: RegisterOAuth2Dto) =>
    new Promise((resolve) => {
      dispatch(
        registerOAuth2({
          values,
          actions: { resolve },
        }),
      );
    });

  const handleReturnToInitForm = () => dispatch(setStage('init'));

  const resendCode = () => {
    new Promise((resolve) => {
      dispatch(
        registerInitOAuth2({
          values: { phone } as RegisterOAuth2InitDto,
          actions: { resolve },
        }),
      );
    });
  };

  return (
    <div>
      <Form
        onSubmit={onSubmit}
        validate={(values) =>
          validator.validate(values, RegisterOAuth2Dto, ['code-verify'])
        }
        render={({
          handleSubmit,
          submitting,
          pristine,
          hasValidationErrors,
          dirtySinceLastSubmit,
        }) => (
          <form onSubmit={handleSubmit}>
            <FormKnownValues>
              <FormKnownValue
                label="Номер телефона"
                value={phone}
                verified={false}
              />
            </FormKnownValues>
            <Box mt="24">
              <TextInput
                name="code"
                label="Код подтверждения"
                placeholder="Введите код"
                type="number"
                inputMode="numeric"
                autocomplete="one-time-code"
                id="qaAuthRegisterVerifyCodeInput"
                testId="test-id-verify-code-input"
              />
            </Box>
            <Box mb="12">
              <Callout>
                <Typography color="text.light.primary" variant="body3">
                  Код поступит в MAX или придёт по СМС
                </Typography>
              </Callout>
            </Box>
            <Redo label="Отправить код повторно" action={resendCode} />
            <Box mt={{ xs: '32', md: '48' }}>
              <Button
                color={buttonColor && `#${buttonColor}`}
                disabled={submitting || pristine || hasValidationErrors}
                className="qaSubmitButton"
                testId="test-id-code-accept-button"
              >
                Подтвердить
              </Button>
            </Box>
            {!dirtySinceLastSubmit && status && status === 'failed' && (
              <FormError error={error} />
            )}
            <Box mt={{ xs: '24', md: '16' }}>
              <Link
                onClick={handleReturnToInitForm}
                size="small"
                variant="tertiary"
                startIcon={<Icon name="chevron_left" size="16" />}
              >
                Вернуться назад
              </Link>
            </Box>
          </form>
        )}
      />
    </div>
  );
};
